<template>
    <div>
        <div class="row m-b-md" v-for="(file, index) in files">
            <div class="col-md-3 wizard-image">
                <thumb-autoupdate-upload :preview-url="file.thumb" :name="file.title"/>
            </div>
            <div class="col-md-9 wizard-title d-flex flex-column">
                <div class="d-flex flex-row">
                    <div v-if="file.file_duplicate_checksum === true" class="w-100">
                        <div class="d-flex flex-row" style="margin-top: -4px;">
                            <div v-if="!file.use" class="mb-2">
                                {{ t_message_title_exists_1 }}<span style="font-style: italic;">"{{ file.title }}"</span>{{ t_message_title_exists_2 }}
                            </div>
                            <v-btn v-if="!file.use" type="button" class="btn btn-secondary square-icon-button pull-right" @click="remove_file(index)">
                                <i class="fa-regular fa-trash"></i>
                            </v-btn>
                        </div>
                        <div class="mb-4">
                            <HeaderCheckbox
                                :selectMessage=t_upload_anyways
                                :deselectMessage=t_upload_anyways
                                :checked="file.use"
                                small
                                @change="({checked}) => checked ? file.use = true : file.use = false"
                            />
                            <span class="ml-2">{{ t_upload_anyways }}</span>
                            <div v-if="only_title_has_warning(file) && file.use"
                                 class="pull-right text-warning font-bold">
                                {{ t_error_title_exists }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-row">
                    <div class="d-flex flex-column w-100">
                        <div v-if="file.use === true">
                            <div v-bind:class="[title_has_error(file, index) ? 'has-error' : (title_has_warning(file, index) ? 'has-warning' : !detailed_edit[index] ? 'pb-3': ''), 'clearfix']">

                                <v-text-field v-model="file.title"
                                              :label="t_title"
                                              :name="t_title"
                                              @keyup="setFilename(index);checkUploadedFiles(true, index);$event.target.focus()"
                                              outlined
                                              dense
                                ></v-text-field>

                                <div v-if="detailed_edit[index] && !file.title.length" style="margin-top: -12px; margin-bottom: 18px;"
                                     class="text-danger font-bold">{{ t_error_cannot_be_empty }}
                                </div>
                                <div v-if="!detailed_edit[index] && file_name_has_warning(file)" style="margin-top: -12px;"
                                     class="text-warning font-bold">{{ t_warning_filename_exists(file) }}
                                </div>
                                <div v-if="!detailed_edit[index] && !file.title.length" style="margin-top: -12px;"
                                     class="text-danger font-bold">{{ t_error_cannot_be_empty }}
                                </div>
                                <div v-if="!detailed_edit[index] && file.file_regex" style="margin-top: -12px;"
                                     class="text-danger font-bold">{{ t_error_filename_regex }}
                                </div>
                            </div>

                            <div v-if="detailed_edit[index]" v-bind:class="[file_name_has_error(file) ? 'has-error form-group' : (file_name_has_warning(file) ? 'has-warning form-group' : ''), 'clearfix']">
                                <div :class="file.file_duplicate_system !== false && file.file_duplicate_upload !== true ? '' : 'hidden'"
                                     class="form-group m-b-xs m-t-n-xxs" style="margin-top: -4px;">
                                    <label v-if="file.file_duplicate_system === 'overwritable'" class="m-r-sm">{{ file.label }}
                                        <div class="mb-4">
                                            <HeaderCheckbox
                                                :id="'overwrite-select-'+file.id"
                                                v-model="file.file_overwrite"
                                                :selectMessage=t_overwrite_yes
                                                :deselectMessage=t_overwrite_no
                                                :checked="file.file_overwrite"
                                                small
                                                @change="({checked}) => checked ? file.file_overwrite = 1 : file.file_overwrite = 0"
                                            />
                                            <span class="ml-2">{{ t_overwrite_yes }}</span>
                                        </div>
                                    </label>
                                </div>
                                <div class="form-group">
                                    <div class="d-flex flex-row">
                                        <v-text-field v-model="file.file_name"
                                                      :label="t_filename"
                                                      :name="t_filename"
                                                      @keyup="checkUploadedFiles(true, index);$event.target.focus()"
                                                      outlined
                                                      dense
                                                      class="rounded-right-0"
                                        ></v-text-field>
                                        <span class="input-group-addon d-flex flex-column justify-center" style="height: 40px; width: unset; border-top-right-radius: 4px; border-bottom-right-radius: 4px;">.{{ file.file_extension }}</span>
                                    </div>
                                </div>
                                <div v-if="file_name_has_warning(file)"
                                     class="pull-right text-warning font-bold"
                                     style="margin-top: -28px;">{{ t_warning_filename_exists(file) }}
                                </div>
                                <div v-if="!file.file_name" style="margin-top: -28px;"
                                     class="text-danger font-bold">{{ t_error_cannot_be_empty }}
                                </div>
                                <div v-if="file.file_regex === true" style="margin-top: -28px;"
                                     class="text-danger font-bold">{{ t_error_filename_regex }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div v-if="file.use === true && !detailed_fixed[index]" class="btn detail-button" @click="toggle_detailed_edit(index)">
                            <i class="fa-regular fa-chevron-up" v-if="detailed_edit[index]"></i>
                            <i class="fa-regular fa-chevron-down" v-else></i>
                        </div>
                        <v-btn v-if="file.use" type="button" class="btn btn-secondary square-icon-button" @click="remove_file(index)">
                            <i class="fa-regular fa-trash"></i>
                        </v-btn>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import HeaderCheckbox
        from "../../common/PrimeVue/HeaderCheckbox.vue";

    export default {
        components: {
            HeaderCheckbox,
            bool:       require('../../../common/bool.vue').default,
            thumbAutoupdateUpload:  require('../../common/thumb-autoupdate-upload.vue').default,
        },
        props: ['files'],
        data: function () {
            return {
                t_title: Lang.langGet("Title"),
                t_filename: Lang.langGet("Filename"),
                t_overwrite_yes: Lang.langGet("Overwrite"),
                t_overwrite_no: Lang.langGet("Don't Overwrite"),
                t_error_title_exists: Lang.langGet("The title already exists!"),
                t_upload_anyways: Lang.langGet("Upload anyways"),
                t_message_title_exists_1: Lang.langGet("The file with title "),
                t_message_title_exists_2: Lang.langGet(" already exists."),
                t_error_cannot_be_empty: Lang.langGet('Name cannot be empty!'),
                file_count: 0,
                detailed_edit: [],
                detailed_fixed: [],
            }
        },
        computed: {
            t_error_filename_regex: function() {
                if(Laravel.filenameRegex === null) {
                    return Lang.langGet("File names must not contain the following symbols: ' * \" / : < > ? \\ | '");
                } else {
                    return Lang.langGet("File names must match this regex: :regex", {regex: Laravel.filenameRegex});
                }
            },
        },
        watch: {
            files: function (list) {
                let size = _.size(list);

                if (size > 0 && this.file_count !== size) {
                    this.file_count = size;
                    this.checkUploadedFiles();
                }
            }
        },
        methods: {
            t_warning_filename_exists: function (file) {
                return Lang.langGet("File will be saved as ':filename'.", {filename: file.file_dont_overwrite_filename + '.' + file.file_extension});
            },
            file_name_has_warning: function (file) {
                return ((file.file_duplicate_system !== false || file.file_duplicate_upload === true) && file.file_overwrite === 0)
            },
            file_name_has_error: function (file) {
                return file.file_regex === true
            },
            title_has_error: function (file, index) {
                let title_error = file.title.length === 0;
                title_error = title_error ? title_error : (this.detailed_edit[index] ? false : this.file_name_has_error(file));
                return title_error;
            },
            only_title_has_warning: function (file) {
                let title_warning = (file.title_duplicate_system === 'overwritable' || file.title_duplicate_upload === true) && file.file_overwrite === 0;
                return title_warning;
            },
            title_has_warning: function (file, index) {
                let title_warning = (file.title_duplicate_system === 'overwritable' || file.title_duplicate_upload === true) && file.file_overwrite === 0;
                title_warning = title_warning ? title_warning : (this.detailed_edit[index] ? false : this.file_name_has_warning(file));
                return title_warning;
            },
            toggle_detailed_edit(index) {
                Vue.set(this.detailed_edit, index, !this.detailed_edit[index])
            },
            remove_file(index) {
                this.files.splice(index, 1);
            },
            // t_exists: function (title) {
            //     return Lang.langGet("The file already exists with title \":title\". Upload anyways?", {title: title});
            // },
            // t_error_filename_regex: function(symbols) {
            //     return Lang.langGet("File name contains illegal symbols: ' :matches '", {matches: symbols});
            // },
            setFilename: function (index) {
                if (!this.detailed_edit[index] && !this.detailed_fixed[index]) {
                    this.files[index].file_name = this.files[index].title;
                }
            },
            checkUploadedFiles: function (all, until) {
                if (until === undefined) {
                    for (let i = 0; i < _.size(this.files); i++) {
                        this.checkUploadedFiles(all, i);
                    }
                } else {
                    if (all !== undefined) {
                        axios.post('/content/mediapool/check', {
                            file_name: this.files[until].file_name,
                            file_extension: this.files[until].file_extension,
                            title: this.files[until].title
                        }).then((response) => {
                            this.files[until].file_duplicate_system = response.data.data.file_duplicate_system;
                            this.files[until].file_regex = response.data.data.file_regex;
                            this.files[until].title_duplicate_system = response.data.data.title_duplicate_system;
                            this.files[until].file_dont_overwrite_filename = response.data.data.file_dont_overwrite_filename;
                            // this.files[until].illegal_symbols = response.data.data.symbols;

                            if(this.files[until].file_duplicate_system === false && this.files[until].file_overwrite > 0) {
                                this.files[until].file_overwrite = 0;
                            }

                            this.checkPreviousFiles(until);

                            if (until + 1 < _.size(this.files)) {
                                for (let i = until + 1; i < _.size(this.files); i++) {
                                    this.checkPreviousFiles(i);
                                }
                            }
                        }).catch((error) => {
                            if (error.response.status === 401) {
                                window.location = '/login';
                            }
                        });
                    } else {
                        this.checkPreviousFiles(until);
                    }
                }
            },
            checkPreviousFiles: function (until) {
                let referenceElement = this.files[until];
                referenceElement.title_duplicate_upload = false;
                referenceElement.file_duplicate_upload = false;

                for (let i = 0; i < until; i++) {
                    if (referenceElement.title === this.files[i].title) {
                        referenceElement.title_duplicate_upload = 'overwritable';
                    }

                    if (referenceElement.file_name === this.files[i].file_name &&
                        referenceElement.file_extension === this.files[i].file_extension) {
                        referenceElement.file_duplicate_upload = 'overwritable';
                    }
                }

                if (this.file_name_has_error(referenceElement) && !this.title_has_error(referenceElement)) {
                    Vue.set(this.detailed_fixed, until, true);
                    Vue.set(this.detailed_edit, until, true);
                } else {
                    Vue.set(this.detailed_fixed, until, false);
                }
            }
        }
    }
</script>
